import {getAppConfigSetting} from "../../../utils";

export const FETCH_MENU_ITEMS_REQUEST = "FETCH_MENU_ITEMS_REQUEST";
export const FETCH_MENU_ITEMS_SUCCESS = "FETCH_MENU_ITEMS_SUCCESS";
export const FETCH_MENU_ITEMS_FAILURE = "FETCH_MENU_ITEMS_FAILURE";

export const URL = `${getAppConfigSetting('apiUrl')}/legit/api/v2/session/menuItems`;
